/* eslint-disable */
/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useReducer, useState } from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useAuth, handleLogin } from "context/auth";
import {  useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import OtpInput from "react-otp-input";
import Select from "react-select";
import { useLoading, handleLoading } from "context/LoadingContext";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import Dialog from "components/Dialog/Dialog";
import getFeature from "utils/getFeature";
import { NotificationManager } from "react-notifications";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function Login() {
  const [auth, dispatchAuth] = useAuth();
  const navigate = useNavigate();
  const [, loadingDispatch] = useLoading();
  // reCaptcha
  const [reCaptcha, setReCaptcha] = useState(null);
  const [offices, setOffices] = useState([]);
  const reCaptchaOnChange = (value) => {
    setReCaptcha(value);
  };
  
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm({
    defaultValues: {
      otpNumber: "",
    },
  });
  const [userTypeInput] = useState("user");
  const [otp, setOtp] = useState("");
  const handleOtpChange = (otpInput) => setOtp(otpInput);
  const [dialogState, dispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleDialog = () => {
    dispatchDialog({ type: "TOGGLE" });
    if (auth.otpRequired) {
      dispatchAuth({ type: "INIT", payload: { otpRequired: false } });
      setOtp("");
    }
  };
  //
  const [conditionsDialogState, dispatchConditionsDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleConditionDialog = () => {
    dispatchConditionsDialog({ type: "TOGGLE" });
  };
  //

  useEffect(() => {
    if (auth.otpRequired) {
      toggleDialog();
    }
  }, [auth.otpRequired]);

  useEffect(() => {
    reset({});
  }, [userTypeInput]);

  const onSubmit = async (data) => {
    const tempData = { ...data };
    tempData.cardNumber = tempData?.cardNumber?.toUpperCase();
    if (!reCaptcha) return;
    try {
      handleLoading(loadingDispatch, true);
      await handleLogin(
        dispatchAuth,
        { ...tempData, otpNumber: otp },
        userTypeInput
      );
      setOtp("");
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };
  useEffect(() => {
    if (auth.isLoggedIn) navigate("/");
  }, [auth.isLoggedIn]);

  useEffect(() => {
    (async () => {
      try {
        const feature = await getFeature(
          "https://sp.pdtra.gov.jo/arcgis/rest/services/Offices/MapServer/12"
        );
        setOffices(feature.map((item) => item.attributes));
      } catch (error) {
        ErrorHandelFunctionApp(error)
      }
    })();
  }, []);

  return (
    <>
      <form
        className="auth__container"
        id="login"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        // style={{background:"red"}}
      >
        <h2>
          <img
            src={`${process.env.PUBLIC_URL}/petra_logo_web.svg`}
            alt="خدمة اصدار مخطط موقع وترسيم"
            className="max-w-100"
          />
        </h2>
        <h3>خدمة اصدار مخطط موقع وترسيم</h3>
        {userTypeInput === "user" && (
          <>
            <Form.Group
              className="mb-3 input input-md"
              controlId="userNationalId"
            >
              <Form.Label>الرقم الوطني</Form.Label>
              <Form.Control
                autoComplete="false"
                type="text"
                {...register("userNationalId", {
                  required: "الرجاء ادخال الرقم الوطني",
                  pattern: {
                    value: /^[0-9]*$/,
                    message: "حقل يجب أن يحتوي فقط على أرقام",
                  },
                  minLength: {
                    value: 10,
                    message: "يجب أن يحتوي الحقل على 10 ارقام",
                  },
                  maxLength: {
                    value: 10,
                    message: "يجب أن يحتوي الحقل على 10 ارقام",
                  },
                })}
              />
              {errors.userNationalId && (
                <Form.Text className="text-danger">
                  {errors.userNationalId.message}
                </Form.Text>
              )}
            </Form.Group>
            <Form.Group className="mb-3 input input-md" controlId="officeNo">
              <Form.Label>مكتب القيد</Form.Label>
              <Controller
                control={control}
                defaultValue=""
                name="officeNo"
                render={({ field: { onChange, name, ref } }) => (
                  <Select
                    inputRef={ref}
                    name={name}
                    classNamePrefix="react-select"
                    options={offices}
                    getOptionValue={(option) => option.OFFICE_NAME}
                    getOptionLabel={(option) => option.OFFICE_NAME}
                    onChange={(val) => {
                      onChange(val.CIV_OFF_BIRTH_OFF);
                    }}
                  />
                )}
                rules={{
                  required: "الرجاء إدخال الحقل",
                }}
              />
              {errors.officeNo && (
                <Form.Text className="text-danger">
                  {errors.officeNo.message}
                </Form.Text>
              )}
            </Form.Group>
            <Form.Group className="mb-4 input input-md" controlId="civNo">
              <Form.Label>رقم القيد</Form.Label>
              <Form.Control
                {...register("civNo", {
                  required: "الرجاء ادخال رقم القيد",
                })}
              />
              {errors.civNo && (
                <Form.Text className="text-danger">
                  {errors.civNo.message}
                </Form.Text>
              )}
            </Form.Group>
            <Form.Group className="mb-4 input input-md" controlId="phoneNumber">
              <Form.Label>رقم الهاتف</Form.Label>
              <Form.Control
                {...register("phoneNumber", {
                  required: "الرجاء رقم الهاتف",
                  pattern: {
                    value: /^078[0-9]*$|^077[0-9]*$|^079[0-9]*$/,
                    message: "الرجاء ادخال رقم هاتف صحيح",
                  },
                  minLength: {
                    value: 10,
                    message: "يجب أن يحتوي الحقل على 10 ارقام",
                  },
                  maxLength: {
                    value: 10,
                    message: "يجب أن يحتوي الحقل على 10 ارقام",
                  },
                })}
              />
              {errors.phoneNumber && (
                <Form.Text className="text-danger">
                  {errors.phoneNumber.message}
                </Form.Text>
              )}
            </Form.Group>
            <Form.Group className="mb-4 input input-md" controlId="conditions">
              <Form.Check
                type="conditions"
                id="check-api-conditions"
                value
                style={{ display: "flex", alignItems: "center" }}
              >
                <button
                  type="button"
                  style={{ textAlign: "right", width: "fit-content" }}
                  onClick={toggleConditionDialog}
                >
                  الشروط والاحكام
                </button>
                <Form.Check.Input
                  type="checkbox"
                  {...register("conditions", {
                    required: "الرجاء تحديد الإختيار",
                  })}
                />
              </Form.Check>
              {errors.conditions && (
                <Form.Text className="text-danger">
                  {errors.conditions.message}
                </Form.Text>
              )}
            </Form.Group>
          </>
        )}
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_reCAPTCHA_SITE_KEY}
          onExpired={() => {}}
          onChange={reCaptchaOnChange}
          className="ReCAPTCHA"
        />
        <button type="submit" className="btn--outline" disabled={!reCaptcha}>
          تسجيل الدخول
        </button>
      </form>
      <Dialog
        state={dialogState}
        dispatch={dispatchDialog}
        footer={false}
        title="الرجاء ادخال رمز التحقق"
        closeButton
        centered
        className="z-1057"
        backdropClassName="z-1056"
      >
        <div
          style={{
            direction: "ltr",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <OtpInput
            value={otp}
            onChange={handleOtpChange}
            numInputs={4}
            separator={<span className="mx-1" />}
            isInputNum
            shouldAutoFocus
            className="mb-4"
          />
        </div>
        <button
          type="submit"
          className="btn btn--primary w-100 text-center"
          form="login"
        >
          تأكيد
        </button>
      </Dialog>
      <Dialog
        state={conditionsDialogState}
        dispatch={toggleConditionDialog}
        footer={false}
        title="الشروط والاحكام"
        closeButton
        centered
        className="z-1057"
        backdropClassName="z-1056"
      >
        <p>
          أتعهد وأقر بصحة جميع المعلومات الواردة أعلاه وأتحمل كامل المسؤولية
          القانونية والقضائية في حال تبين عدم صحة هذه المعلومات مستقبلا
        </p>
      </Dialog>
    </>
  );
}

export default Login;
